// "Chat with customer" — opens the WhatsApp conversation for a booking's customer in a new
// tab (/app/chat?userId=<digits>), so the queue stays where it is. Same existence check and
// error text as the order modal; chats are keyed by country code + number digits (wa_id).
import React, { useState } from 'react';
import { Button } from 'reactstrap';
import WhatsappIcon from '../../../../assets/css/img/whatsapp.png';
import { firestore } from '../../../../helpers/Firebase';
import { createNotification, validateNumber } from '../../../../helpers/Utils';

export const chatIdForBooking = (booking) => {
  if (!booking?.customer_number) return null;
  const n = Number(validateNumber((booking.country_code || '971'), booking.customer_number));
  return Number.isFinite(n) && n > 0 ? String(n) : null;
};

const ChatWithCustomerButton = ({ booking, size = 'sm', className = '', label = 'Chat with customer' }) => {
  const [busy, setBusy] = useState(false);
  const waId = chatIdForBooking(booking);

  const open = async () => {
    if (!waId) { createNotification('error', 'No customer number on this order', 'Error'); return; }
    setBusy(true);
    try {
      const snap = await firestore().collection('chats').doc(waId).get();
      if (!snap.exists) { createNotification('error', 'Customer is not available on WhatsApp', 'Error'); return; }
      window.open(`/app/chat?userId=${encodeURIComponent(waId)}`, '_blank', 'noopener');
    } catch (e) {
      createNotification('error', e?.message || 'Could not open the chat', 'Error');
    } finally { setBusy(false); }
  };

  return (
    <Button color="success" outline size={size} className={`d-inline-flex align-items-center ${className}`} disabled={busy || !waId} onClick={open} title={waId ? `+${waId}` : ''}>
      <img style={{ width: '16px', marginRight: '6px' }} alt="" src={WhatsappIcon} />{busy ? 'Opening…' : label}
    </Button>
  );
};

export default ChatWithCustomerButton;
